const contractDocumentConfigurationRoute = {
  path: 'provider',
  component: () =>
    import(
      '@/views/provider/contract-document-configuration-management/Wrapper.vue'
    ),
  children: [
    {
      path: '/provider/contract-document-configuration',
      name: 'contractDocumentConfigurationSearch',
      component: () =>
        import(
          '@/views/provider/contract-document-configuration-management/Main.vue'
        ),
      meta: {
        authorization: {
          requiresAuth: true,
          permissions: ['menu.rempro.provider.contractdocumentconfiguration'],
        },
      },
    },
    {
      path:
        '/provider/contract-document-configuration/history/:contractTemplateId',
      name: 'contractTemplateHistory',
      component: () =>
        import(
          '@/views/provider/contract-document-configuration-management/ContractTemplateHistory.vue'
        ),
      meta: {
        authorization: {
          requiresAuth: true,
          permissions: ['menu.rempro.provider.contractdocumentconfiguration'],
        },
      },
    },
    {
      path: '/provider/contract-document-management/:contractTemplateId?',
      name: 'contractDocumentConfigurationManagement',
      component: () =>
        import(
          '@/views/provider/contract-document-configuration-management/ContractDocumentConfigurationManagement.vue'
        ),
      meta: {
        authorization: {
          requiresAuth: true,
          permissions: ['menu.rempro.provider.contractdocumentconfiguration'],
        },
      },
    },
  ],
};

export default contractDocumentConfigurationRoute;
